export default "__VITE_ASSET__ffb39a4c__"